import { C, sans, mono, type, space, radius, border, icon } from "../theme.ts";
import type { PantryItem } from "../api.ts";

/**
 * One pantry line: the tick, the name, and — on its own row, never totalled
 * — a tag saying a write has not landed yet or was refused. Ticking is the
 * only interaction; there is no count, no date, no quantity here or ever.
 */
export function PantryRow({
  item, on, tag, onToggle,
}: {
  item: PantryItem;
  on: boolean;
  tag: string | null;
  onToggle: () => void;
}) {
  return (
    <div
      onClick={onToggle}
      style={{
        display: "flex", alignItems: "flex-start", gap: space.md,
        padding: `${space.md}px ${space.xxs}px`, minHeight: 48, boxSizing: "border-box", cursor: "pointer",
        borderBottom: `${border.hairline}px solid ${C.rule}`, fontFamily: sans,
      }}
    >
      <span style={{
        width: icon.tick, height: icon.tick, borderRadius: radius.sm, flexShrink: 0, marginTop: space.xxs,
        border: `${border.hairline}px solid ${on ? C.inkSoft : C.ruleStrong}`,
        background: on ? C.inkSoft : "transparent",
      }} />
      <span style={{
        fontSize: type.bodyLarge, lineHeight: 1.4,
        color: on ? C.inkGhost : C.ink,
        textDecoration: on ? "line-through" : "none",
      }}>
        {item.name}
        {tag && (
          <span style={{
            fontFamily: mono, fontSize: type.micro, color: C.inkGhost,
            letterSpacing: 0.6, marginLeft: space.ms, whiteSpace: "nowrap",
          }}>{tag}</span>
        )}
      </span>
    </div>
  );
}
